import { Divider, DividerProps } from '@mui/material';
import React from 'react';
import { colors } from '../utils/theme';

export const RootineDivider = ({
  dividerProps,
}: {
  dividerProps?: DividerProps;
}): JSX.Element => {
  return (
    <Divider
      {...dividerProps}
      sx={{ ...dividerProps?.sx, background: colors.greys.BORDER_GREY }}
    />
  );
};
